import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import { isDarkTheme } from "../../helpers/darkTint";
import { Avatar, Card, CardHeader } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import { compactTicketHeader } from "../TicketHeader/compactStyles";

const useStyles = makeStyles(theme => ({
	ticketHeader: {
		display: "flex",
		// No escuro usa o mesmo fundo do TicketHeader real (tabHeaderBackground)
		backgroundColor: isDarkTheme(theme) ? theme.palette.tabHeaderBackground : "#eee",
		flex: "none",
		borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
		// Tem que casar com TicketHeader, senão o cabeçalho muda de altura
		// quando o ticket sai do estado de carregamento.
		...compactTicketHeader(),
	},
}));

const TicketHeaderSkeleton = () => {
	const classes = useStyles();

	return (
		<Card square className={classes.ticketHeader}>
			<CardHeader
				titleTypographyProps={{ noWrap: true }}
				subheaderTypographyProps={{ noWrap: true }}
				avatar={
					<Skeleton animation="wave" variant="circle">
						<Avatar alt="contact_image" />
					</Skeleton>
				}
				title={<Skeleton animation="wave" width={80} />}
				subheader={<Skeleton animation="wave" width={140} />}
			/>
		</Card>
	);
};

export default TicketHeaderSkeleton;
